import { createFileRoute, useParams } from '@tanstack/react-router';

import { ClientEditScreen } from '@/features/clients/components/workspace/ClientEditScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/clients/$clientId/edit')({
  beforeLoad: () => {
    requirePermission('client:update');
  },
  component: WorkspaceClientEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspaceClientEditRoute() {
  const { clientId } = useParams({ from: '/_staff/admin/workspace/clients/$clientId/edit' });
  return <ClientEditScreen clientId={clientId} />;
}
